import { createDecorator } from '../../instantiation/common/instantiation.js';
const IExtensionHostDebugService = ( createDecorator('extensionHostDebugService'));
export { IExtensionHostDebugService };
